import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { faqs } from '../../mockData';

const FAQSection = () => {
  return (
    <section id="faq" className="section-light">
      <div className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-lg mb-6">Frequently Asked Questions</h2>
        </div>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} className="border border-[var(--border-color)] rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold hover:no-underline" style={{ color: 'var(--primary-navy)' }}>
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[var(--text-muted)] pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
